import {MainCategoryStep} from "../steps/MainCategoryStep/MainCategoryStep";
import {AccountCategoryStep} from "../steps/AccountCategoryStep";
import {HomeyCloudCategoryStep} from "../steps/HomeyCloudCategoryStep";
import {HomeyProCategoryStep} from "../steps/HomeyProCategoryStep";
import {HomeyProMiniCategoryStep} from "../steps/HomeyProMiniCategoryStep";
import {HomeySelfHostedServerCategoryStep} from "../steps/HomeySelfHostedServerCategoryStep";
import {KnowledgeBaseStep} from "../steps/KnowledgeBaseStep";
import {AppsStep} from "../steps/AppsStep/AppsStep";
import {ContactDeveloperStep} from "../steps/ContactDeveloperStep";
import {EmailDeveloperStep} from "../steps/EmailDeveloperStep";
import {TicketStep} from "../steps/TicketStep/TicketStep";
import {AskTheCommunityStep} from "../steps/AskTheCommunityStep";
import {ManageAccountStep} from "../steps/ManageAccountStep";
import {UpdateAppStep} from "../steps/UpdateAppStep";
import {DevicesStep} from "../steps/DevicesStep/DevicesStep";

export const stepTypes = {
  step: 'step',
  actionStep: 'actionStep',
  finalStep: 'finalStep',
}

export const flowConfig =
  actionStep(MainCategoryStep, {
      [MainCategoryStep.account.action]:
        actionStep(AccountCategoryStep, {
            [AccountCategoryStep.nameAndMail.action]:
              finalStep(ManageAccountStep),
            [AccountCategoryStep.profile.action]:
              finalStep(ManageAccountStep),
            [AccountCategoryStep.delete.action]:
              finalStep(ManageAccountStep),
            [AccountCategoryStep.password.action]:
              finalStep(ManageAccountStep),
            [AccountCategoryStep.mfa.action]:
              finalStep(ManageAccountStep),
            [AccountCategoryStep.other.action]:
              finalStep(TicketStep)
          }
        ),
      [MainCategoryStep.homey.cloud.action]:
        actionStep(HomeyCloudCategoryStep, {
            [HomeyCloudCategoryStep.homeyBridge.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.homeyPortal.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.homeyEnergyDongle.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.apps.action]:
              actionStep(AppsStep, {
                  [AppsStep.contactSupport.action]:
                    finalStep(TicketStep),
                  [AppsStep.contactDeveloper.action]:
                    step(ContactDeveloperStep,
                      rawFinalStep(EmailDeveloperStep)
                    ),
                  [AppsStep.notListed.action]:
                    finalStep(TicketStep),
                  [AppsStep.updateApp.action]:
                    rawFinalStep(UpdateAppStep)
                }
              ),
            [HomeyCloudCategoryStep.devices.action]:
              actionStep(DevicesStep, {
                [DevicesStep.contactSupport.action]:
                  finalStep(TicketStep),
                [DevicesStep.contactDeveloper.action]:
                  step(ContactDeveloperStep,
                    rawFinalStep(EmailDeveloperStep)
                  ),
                [DevicesStep.contactDeveloperWithoutKnowledgeBase.action]:
                  step(ContactDeveloperStep,
                    rawFinalStep(EmailDeveloperStep)
                  ),
                [DevicesStep['433mhz'].action]:
                  finalStep(TicketStep),
                [DevicesStep['868mhz'].action]:
                  finalStep(TicketStep),
                [DevicesStep.bluetooth.action]:
                  finalStep(TicketStep),
                [DevicesStep.infrared.action]:
                  finalStep(TicketStep),
                [DevicesStep.wifi.action]:
                  finalStep(TicketStep),
                [DevicesStep.zigbee.action]:
                  finalStep(TicketStep),
                [DevicesStep.zwave.action]:
                  finalStep(TicketStep),
                [DevicesStep.matter.action]:
                  finalStep(TicketStep),
              }),
            [HomeyCloudCategoryStep.flow.action]:
              finalStep(AskTheCommunityStep),
            [HomeyCloudCategoryStep.logic.action]:
              finalStep(AskTheCommunityStep),
            [HomeyCloudCategoryStep.insights.action]:
              finalStep(AskTheCommunityStep),
            [HomeyCloudCategoryStep.energy.action]:
              finalStep(AskTheCommunityStep),
            [HomeyCloudCategoryStep.dashboards.action]:
              finalStep(AskTheCommunityStep),
            [HomeyCloudCategoryStep.mobileApp.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.webApp.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.alexa.action]:
              finalStep(AskTheCommunityStep),
            [HomeyCloudCategoryStep.google.action]:
              finalStep(AskTheCommunityStep),
            [HomeyCloudCategoryStep.siri.action]:
              finalStep(AskTheCommunityStep),
            [HomeyCloudCategoryStep.defects.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.returns.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep["433mhz"].action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.bluetooth.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.infrared.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.wifi.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.zigbee.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.zwave.action]:
              finalStep(TicketStep),
            [HomeyCloudCategoryStep.family.action]:
              finalStep(AskTheCommunityStep),
            [HomeyCloudCategoryStep.other.action]:
              finalStep(TicketStep),
          }
        ),
      [MainCategoryStep.homey.pro.action]:
        actionStep(HomeyProCategoryStep, {
            [HomeyProCategoryStep.homeyBridge.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.homeyPortal.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.homeyEnergyDongle.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.homeyProEthernetAdapter.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.apps.action]:
              actionStep(AppsStep, {
                  [AppsStep.contactSupport.action]:
                    finalStep(TicketStep),
                  [AppsStep.contactDeveloper.action]:
                    step(ContactDeveloperStep,
                      rawFinalStep(EmailDeveloperStep)
                    ),
                  [AppsStep.notListed.action]:
                    finalStep(TicketStep),
                  [AppsStep.updateApp.action]:
                    rawFinalStep(UpdateAppStep)
                }
              ),
            [HomeyProCategoryStep.devices.action]:
              actionStep(DevicesStep, {
                [DevicesStep.contactSupport.action]:
                  finalStep(TicketStep),
                [DevicesStep.contactDeveloper.action]:
                  step(ContactDeveloperStep,
                    rawFinalStep(EmailDeveloperStep)
                  ),
                [DevicesStep.contactDeveloperWithoutKnowledgeBase.action]:
                  step(ContactDeveloperStep,
                    rawFinalStep(EmailDeveloperStep)
                  ),
                [DevicesStep['433mhz'].action]:
                  finalStep(TicketStep),
                [DevicesStep['868mhz'].action]:
                  finalStep(TicketStep),
                [DevicesStep.bluetooth.action]:
                  finalStep(TicketStep),
                [DevicesStep.infrared.action]:
                  finalStep(TicketStep),
                [DevicesStep.wifi.action]:
                  finalStep(TicketStep),
                [DevicesStep.zigbee.action]:
                  finalStep(TicketStep),
                [DevicesStep.zwave.action]:
                  finalStep(TicketStep),
                [DevicesStep.matter.action]:
                  finalStep(TicketStep),
              }),
            [HomeyProCategoryStep.flow.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProCategoryStep.advancedFlow.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProCategoryStep.logic.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProCategoryStep.insights.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProCategoryStep.energy.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProCategoryStep.dashboards.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProCategoryStep.mobileApp.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.webApp.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.alexa.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProCategoryStep.google.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProCategoryStep.siri.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProCategoryStep.defects.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.returns.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep["433mhz"].action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep["868mhz"].action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.bluetooth.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.matter.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.infrared.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.thread.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.wifi.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.zigbee.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.zwave.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.family.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.backups.action]:
              finalStep(TicketStep),
            [HomeyProCategoryStep.other.action]:
              finalStep(TicketStep),
          }
        ),
      [MainCategoryStep.homey.proMini.action]:
        actionStep(HomeyProMiniCategoryStep, {
            [HomeyProMiniCategoryStep.homeyBridge.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.homeyPortal.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.homeyEnergyDongle.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.apps.action]:
              actionStep(AppsStep, {
                  [AppsStep.contactSupport.action]:
                    finalStep(TicketStep),
                  [AppsStep.contactDeveloper.action]:
                    step(ContactDeveloperStep,
                      rawFinalStep(EmailDeveloperStep)
                    ),
                  [AppsStep.notListed.action]:
                    finalStep(TicketStep),
                  [AppsStep.updateApp.action]:
                    rawFinalStep(UpdateAppStep)
                }
              ),
            [HomeyProMiniCategoryStep.devices.action]:
              actionStep(DevicesStep, {
                [DevicesStep.contactSupport.action]:
                  finalStep(TicketStep),
                [DevicesStep.contactDeveloper.action]:
                  step(ContactDeveloperStep,
                    rawFinalStep(EmailDeveloperStep)
                  ),
                [DevicesStep.contactDeveloperWithoutKnowledgeBase.action]:
                  step(ContactDeveloperStep,
                    rawFinalStep(EmailDeveloperStep)
                  ),
                [DevicesStep['433mhz'].action]:
                  finalStep(TicketStep),
                [DevicesStep['868mhz'].action]:
                  finalStep(TicketStep),
                [DevicesStep.bluetooth.action]:
                  finalStep(TicketStep),
                [DevicesStep.infrared.action]:
                  finalStep(TicketStep),
                [DevicesStep.wifi.action]:
                  finalStep(TicketStep),
                [DevicesStep.zigbee.action]:
                  finalStep(TicketStep),
                [DevicesStep.zwave.action]:
                  finalStep(TicketStep),
                [DevicesStep.matter.action]:
                  finalStep(TicketStep),
              }),
            [HomeyProMiniCategoryStep.flow.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProMiniCategoryStep.advancedFlow.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProMiniCategoryStep.logic.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProMiniCategoryStep.insights.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProMiniCategoryStep.energy.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProMiniCategoryStep.dashboards.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProMiniCategoryStep.mobileApp.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.webApp.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.alexa.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProMiniCategoryStep.google.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProMiniCategoryStep.siri.action]:
              finalStep(AskTheCommunityStep),
            [HomeyProMiniCategoryStep.defects.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.returns.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.matter.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.thread.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.zigbee.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.family.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.backups.action]:
              finalStep(TicketStep),
            [HomeyProMiniCategoryStep.other.action]:
              finalStep(TicketStep),
          }
        ),
      [MainCategoryStep.homey.shs.action]:
        actionStep(HomeySelfHostedServerCategoryStep, {
            [HomeySelfHostedServerCategoryStep.homeyBridge.action]:
              finalStep(TicketStep),
            [HomeySelfHostedServerCategoryStep.homeyPortal.action]:
              finalStep(TicketStep),
            [HomeySelfHostedServerCategoryStep.homeyEnergyDongle.action]:
              finalStep(TicketStep),
            [HomeySelfHostedServerCategoryStep.apps.action]:
              actionStep(AppsStep, {
                  [AppsStep.contactSupport.action]:
                    finalStep(TicketStep),
                  [AppsStep.contactDeveloper.action]:
                    step(ContactDeveloperStep,
                      rawFinalStep(EmailDeveloperStep)
                    ),
                  [AppsStep.notListed.action]:
                    finalStep(TicketStep),
                  [AppsStep.updateApp.action]:
                    rawFinalStep(UpdateAppStep)
                }
              ),
            [HomeySelfHostedServerCategoryStep.devices.action]:
              actionStep(DevicesStep, {
                [DevicesStep.contactSupport.action]:
                  finalStep(TicketStep),
                [DevicesStep.contactDeveloper.action]:
                  step(ContactDeveloperStep,
                    rawFinalStep(EmailDeveloperStep)
                  ),
                [DevicesStep.contactDeveloperWithoutKnowledgeBase.action]:
                  step(ContactDeveloperStep,
                    rawFinalStep(EmailDeveloperStep)
                  ),
                [DevicesStep['433mhz'].action]:
                  finalStep(AskTheCommunityStep),
                [DevicesStep.bluetooth.action]:
                  finalStep(AskTheCommunityStep),
                [DevicesStep.infrared.action]:
                  finalStep(AskTheCommunityStep),
                [DevicesStep.wifi.action]:
                  finalStep(AskTheCommunityStep),
                [DevicesStep.zigbee.action]:
                  finalStep(AskTheCommunityStep),
                [DevicesStep.zwave.action]:
                  finalStep(AskTheCommunityStep),
                [DevicesStep.matter.action]:
                  finalStep(AskTheCommunityStep),
              }),
            [HomeySelfHostedServerCategoryStep.flow.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.advancedFlow.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.logic.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.insights.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.energy.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.dashboards.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.mobileApp.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.webApp.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.alexa.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.google.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.siri.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep["433mhz"].action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.bluetooth.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.matter.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.infrared.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.thread.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.wifi.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.zigbee.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.zwave.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.family.action]:
              finalStep(AskTheCommunityStep),
            [HomeySelfHostedServerCategoryStep.other.action]:
              finalStep(AskTheCommunityStep),
          }
        ),
      [MainCategoryStep.homey.notListed.action]:
        finalStep(TicketStep),
      [MainCategoryStep.orders.order.action]:
        finalStep(TicketStep),
      [MainCategoryStep.orders.notListed.action]:
        finalStep(TicketStep),
      [MainCategoryStep.subscriptions.backups.action]:
        finalStep(TicketStep),
      [MainCategoryStep.subscriptions.premium.action]:
        finalStep(TicketStep),
      [MainCategoryStep.subscriptions.selfHostedServerMonthly.action]:
        finalStep(TicketStep),
      [MainCategoryStep.subscriptions.selfHostedServerLifetime.action]:
        finalStep(TicketStep),
      [MainCategoryStep.subscriptions.developer.action]:
        finalStep(TicketStep),
      [MainCategoryStep.subscriptions.notListed.action]:
        finalStep(TicketStep),
    }
  );

// Use for linear steps, where the following step is predetermined.
function step(Component, next) {
  return {
    type: stepTypes.step,
    Component: Component,
    next: next
  }
}

// Use for branching steps, where the action of the user determines the following step.
function actionStep(Component, actions = {}) {
  return {
    type: stepTypes.actionStep,
    Component: Component,
    actions: actions
  }
}

// Use for final steps preceded by KnowledgeBaseStep (auto-skips if no articles are found).
function finalStep(Component) {
  return step(KnowledgeBaseStep, rawFinalStep(Component));
}

// Use for final steps without a preceding KnowledgeBaseStep.
function rawFinalStep(Component) {
  return {
    type: stepTypes.finalStep,
    Component: Component,
  }
}
